/*
* phone.js
*
* German mobile phone helpers for DD 2FA SMS (country code 49).
*
*/

/*******************************************************************************
* normalizeGermanPhone()
*
* Desc: Strip to digits and ensure leading country code 49.
*
*/
export function normalizeGermanPhone(phone) {
    let digits = (phone || '').replace(/\D/g, '');

    if (digits.startsWith('0049')) {
        digits = '49' + digits.slice(4);
    } else if (digits.startsWith('0')) {
        digits = '49' + digits.slice(1);
    } else if (digits.length > 0 && !digits.startsWith('49')) {
        digits = '49' + digits;
    }

    return digits;
}


/*******************************************************************************
* formatGermanPhoneDisplay()
*
* Desc: Pretty-print as +49 171 1234567 (spaces after country and prefix).
*
*/
export function formatGermanPhoneDisplay(phone) {
    const digits = normalizeGermanPhone(phone);

    if (!digits) {
        return '';
    }

    if (!digits.startsWith('49')) {
        return (phone || '').replace(/\s/g, '');
    }

    const national = digits.slice(2);

    if (!national) {
        return '+49';
    }

    let prefixLen = 3;

    if (national.startsWith('1')) {
        prefixLen = 3;
    } else if (/^[23456789]/.test(national)) {
        prefixLen = Math.min(2, national.length);
    } else {
        prefixLen = Math.min(3, national.length);
    }

    const prefix = national.slice(0, prefixLen);
    const rest = national.slice(prefixLen);
    let formatted = '+49 ' + prefix;

    if (rest) {
        formatted += ' ' + rest;
    }

    return formatted;
}


/*******************************************************************************
* isValidGermanPhone()
*
* Desc: Require country code 49 and plausible German number length.
*
*/
export function isValidGermanPhone(phone) {
    const digits = normalizeGermanPhone(phone);

    return /^49[1-9][0-9]{8,10}$/.test(digits);
}


/*******************************************************************************
* toGermanPhoneApi()
*
* Desc: E.164-style value for API calls (+491701234567).
*
*/
export function toGermanPhoneApi(phone) {
    const digits = normalizeGermanPhone(phone);

    if (!digits) {
        return '';
    }

    return '+' + digits;
}
